import { render } from "./illnessPush.vue?vue&type=template&id=323e09f3&scoped=true"
import script from "./illnessPush.vue?vue&type=script&lang=js"
export * from "./illnessPush.vue?vue&type=script&lang=js"

import "./illnessPush.vue?vue&type=style&index=0&id=323e09f3&lang=scss&scoped=true"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323e09f3"]])

export default __exports__